module.exports = __webpack_public_path__ + "static/media/money-pig.3545ce23.svg";